<div class="subtitles" *ngIf="referenceMonth >=0">
  <fieldset>
    <legend>Legenda (Cores de fundo contratos de serviço)</legend>
    <div class="badges">
      <div class="badge" style="background-color: rgb(124, 245, 74);color: rgb(124, 245, 74);"></div>
      Vencem em {{getLabelMonth(0)}}
      <div class="badge" style="background-color: rgb(253, 221, 51);color: rgb(253, 221, 51);"></div>
      Vencem em {{getLabelMonth(1)}}
      <div class="badge" style="background-color: rgb(255 154 154);color: rgb(255 154 154);"></div>
      Contrato vencido
    </div>
  </fieldset>
  <fieldset>
    <legend>Legenda (Cores da letra)</legend>
    <div class="badges">
      <div class="badge" style="background-color: rgb(33, 150, 243);color: rgb(33, 150, 243);"></div>
      Ok
      <div class="badge" style="background-color: green;color: green;"></div>
      Ok, não possui valor à pagar
      <div class="badge" style="background-color: red;color: red;"></div>
      Sem serviço e/ou proprietário
    </div>
  </fieldset>
</div>
<div class="dialog-form">
  <form class="filters" appFilters>
    <div class="filter-row">
      <div class="form-control drop-down-select large" *ngIf="loggedMarina?.marinaCompanies?.length > 0">
        <label>Empresa</label>
        <p-dropdown *ngIf="marinaCompaniesList" placeholder="Selecione..." [options]="marinaCompaniesList"
                    appendTo="body" [(ngModel)]="company" name="company" (onChange)="filterCompanies()">
        </p-dropdown>
      </div>
      <div class="form-control">
        <label>Grupo</label>
        <p-multiSelect defaultLabel="Selecione..." [options]="groups" [style]="{height: '30px'}"
                       appendTo="body" [(ngModel)]="groupIds" name="groupIds"
                       selectedItemsLabel="{0} itens selecionados">
        </p-multiSelect>
      </div>
      <div class="form-control drop-down-select">
        <label>Mês de Referência</label>
        <p-dropdown placeholder="Selecione..." [options]="monthsReference" [(ngModel)]="referenceMonth"
                    appendTo="body" name="referenceMonth" (onChange)="cleanTuitions()">
        </p-dropdown>
      </div>
      <div class="form-control drop-down-select">
        <label>Ano de Referência</label>
        <p-dropdown placeholder="Selecione..." [options]="yearsReference" (onChange)="cleanTuitions()" appendTo="body"
                    [(ngModel)]="referenceYear" name="referenceYear"
        >
        </p-dropdown>
      </div>
      <div class="form-control drop-down-select">
        <label>Status</label>
        <p-multiSelect
          defaultLabel="Selecione..."
          [options]="statusFilterOptions"
          appendTo="body"
          [(ngModel)]="statusFilter"
          name="statusFilter"
          [maxSelectedLabels]="2"
          selectedItemsLabel="{0} status selecionados"
          (onChange)="changefilter()">
        </p-multiSelect>
      </div>

      <div class="form-control drop-down-select large">
        <label>Serviços Periódicos</label>
        <p-multiSelect
          defaultLabel="Selecione..."
          appendTo="body"
          name="productsList"
          [maxSelectedLabels]="1"
          selectedItemsLabel="{0} itens selecionados"
          [options]="periodicalServiceProductList"
          [(ngModel)]="periodicalServiceProductListIds"
        >
        </p-multiSelect>
      </div>
      <div class="form-control drop-down-select large">
        <label>Contratos de Serviço</label>
        <p-multiSelect
          defaultLabel="Selecione..."
          appendTo="body"
          name="contractList"
          [maxSelectedLabels]="1"
          selectedItemsLabel="{0} itens selecionados"
          [options]="contractList"
          [(ngModel)]="contractListvalues"
        >
        </p-multiSelect>
      </div>
      <!-- <div class="form-control">
        <label>Exibir somente as válidas</label>
        <p-dropdown
          name="showOnlyValid"
          [(ngModel)]="showOnlyValid"
          [options]="showOnlyValidOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione..."
          appendTo="body"
          (onChange)="changeShowOnlyValid()"
        ></p-dropdown>
      </div> -->
      <div class="buttons">
        <div class="form-button">
          <button class="primary easymarine"
                  (click)="viewLaunch()">{{ 'Pré-Visualizar' | translate }}</button>
        </div>
        <div class="form-button" *ngIf="tuitionsTable.length > 0">
          <button class="success easymarine"
                  (click)="dialogMonthlySummary()">{{ 'Resumo' | translate }}</button>
        </div>
        <div class="form-button" *ngIf="selectedTuitions.length > 0">
          <button class="danger easymarine" preventDoubleClickDirective [throttleTime]="500"
                  (throettleClick)="dialogGenerateTuition()">{{ 'Gerar pedidos' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="container table">
  <p-table [value]="tuitionsTable"
    [paginator]="true" [rows]="numberOfRows" [rowsPerPageOptions]="[5,10,20,50,100, 200, 500]" [responsive]="true"
    #tt [globalFilterFields]="['boatName']" autoLayout="true"
           styleClass="easy-table center-header" [(selection)]="selectedTuitions">
    <ng-template pTemplate="caption">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText size="50" placeholder="Embarcação, cliente ou grupo"
                           [(ngModel)]="globalFilter" (input)="filterGlobal()" style="width:auto">
                </span>
    </ng-template>

    <ng-template pTemplate="header">
      <tr *ngIf="loggedMarina?.marinaCompanies?.length > 0">
        <th colspan="2"></th>
        <th colspan="2" class="text-center">Total selecionado</th>
        <th *ngIf="loggedMarina?.marinaCompanies?.length === 0">
                        <span>
                            {{getTotalSelected(loggedMarina)}}
                        </span>
        </th>
        <th colspan="12" *ngIf="loggedMarina?.marinaCompanies?.length === 0"></th>
        <th colspan="11" *ngIf="loggedMarina?.marinaCompanies?.length > 0"></th>
      </tr>
      <tr *ngIf="loggedMarina?.marinaCompanies?.length > 0">
        <th colspan="2">
          {{loggedMarina.companyName}}
        </th>
        <th class="text-right" colspan="2">
          {{getTotalSelected(loggedMarina) | number: '1.2-2'}}
        </th>
        <th colspan="6" *ngIf="loggedMarina?.marinaCompanies?.length > 0"></th>
        <th colspan="5" *ngIf="loggedMarina?.marinaCompanies?.length === 0"></th>
        <th class="text-right">{{getTotalCompany(loggedMarina) | number: '1.2-2'}}</th>
        <th class="text-right">{{getDiscountCompany(loggedMarina) | number: '1.2-2'}}</th>
        <th class="text-right">{{getValueCompany(loggedMarina) | number: '1.2-2'}}</th>
        <th colspan="2"></th>
      </tr>
      <tr *ngFor="let company of loggedMarina?.marinaCompanies">
        <th colspan="2">
          {{company.companyName}}
        </th>
        <th class="text-right" colspan="2">
          {{getTotalSelected(company) | number: '1.2-2'}}
        </th>
        <th colspan="6" *ngIf="loggedMarina?.marinaCompanies?.length > 0"></th>
        <th colspan="5" *ngIf="loggedMarina?.marinaCompanies?.length === 0"></th>
        <th class="text-right">{{getTotalCompany(company) | number: '1.2-2'}}</th>
        <th class="text-right">{{getDiscountCompany(company) | number: '1.2-2'}}</th>
        <th class="text-right">{{getValueCompany(company) | number: '1.2-2'}}</th>
        <th colspan="2"></th>
      </tr>
      <tr>
        <th></th>
        <th class="text-center">{{tuitionsTable.length}} serviços de embarcações</th>
        <th colspan="8" *ngIf="loggedMarina?.marinaCompanies?.length > 0"></th>
        <th colspan="7" *ngIf="loggedMarina?.marinaCompanies?.length === 0"></th>
        <th class="text-right">{{totalValue | number: '1.2-2'}}</th>
        <th class="text-right">{{totalDiscount | number: '1.2-2'}}</th>
        <th class="text-right">{{total | number: '1.2-2'}}</th>
        <th colspan="2"></th>
      </tr>

      <tr class="thead">
        <th class="text-center" *ngIf="isMonthlyPayment()">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="text-center" *ngIf="!isMonthlyPayment()">
          <p-checkbox name="tuitionNotSelected" value="tuitionNotSelected" [disabled]="true">
          </p-checkbox>
        </th>
        <th [pSortableColumn]="'boatName'">
          Embarcação
          <p-sortIcon [field]="'boatName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'shipType'">
          Tipo
          <p-sortIcon [field]="'shipType'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'commercialLength'">
          T
          <p-sortIcon [field]="'commercialLength'"></p-sortIcon>
        </th>
        <th *ngIf="loggedMarina?.marinaCompanies?.length > 0">
          Emp.
        </th>
        <th [pSortableColumn]="'commercialLength'">
          Preço
          <p-sortIcon [field]="'commercialLength'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'observation'">
          Obs
          <p-sortIcon [field]="'observation'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'contractStartDate'">
          Início
          <p-sortIcon [field]="'contractStartDate'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'contractEndDate'">
          Fim
          <p-sortIcon [field]="'contractEndDate'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'productName'">
          Serviço
          <p-sortIcon [field]="'productName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'value'">
          Valor
          <p-sortIcon [field]="'value'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'discount'">
          Desc
          <p-sortIcon [field]="'discount'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'total'">
          Total
          <p-sortIcon [field]="'total'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'generate'">
          P
          <p-sortIcon [field]="'generate'"></p-sortIcon>
        </th>
        <th>

        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-tuition>
      <tr [ngStyle]="{'color': getFontColor(tuition), 'background-color': getBackgroundTuition(tuition)}">
        <td class="text-center" *ngIf="isEnableSelect(tuition)">
          <ng-container *ngIf="tuition.emitterBlock">
            <i class="pi pi-spin pi-spinner" style="color: #2196F3; font-size: 1.2em;" pTooltip="Processando..."></i>
          </ng-container>
          <p-tableCheckbox *ngIf="!tuition.emitterBlock" [value]="tuition"></p-tableCheckbox>
        </td>
        <td *ngIf="!isEnableSelect(tuition)">
          <p-checkbox name="tuition.boatId + '' + tuition.productId"
                      value="tuition.boatId + '' + tuition.productId" [disabled]="true"></p-checkbox>
        </td>
        <td class="font-tuition boat-data">
          <div class="boat-name">
            <i class="pi cursor-pointer" (click)="tuition.show = !tuition.show" [ngClass]="{'pi-angle-down': !tuition.show, 'pi-angle-up': tuition.show}"></i>
            <span class="cursor-pointer"
                  (click)="tuition.show = !tuition.show">{{tuition.boatName}}</span>
          </div>
          <div class="boat-dialog">
            <i style="float: right; font-size: 23px; cursor:pointer" class="pi pi-external-link"
               (click)="openDialogBoatForm(tuition.boatId)" pTooltip="Visualizar embarcação"
               tooltipPosition="bottom"></i>
          </div>
        </td>
        <td class="font-tuition">{{tuition.shipType.toUpperCase() | translate}}</td>
        <td class="font-tuition">{{tuition.commercialLength}}</td>
        <td *ngIf="loggedMarina?.marinaCompanies?.length > 0" class="font-tuition">
          {{getCompany(tuition)}}</td>
        <td class="font-tuition">{{tuition?.getPriceTypeName}}</td>
        <td [pTooltip]="tuition.observation" tooltipPosition="bottom">{{tuition.observation ? 'Sim' : null}}</td>
        <td class="font-tuition">{{tuition.contractStartDate | date:'dd/MM/yy'}}</td>
        <td class="font-tuition">{{tuition.contractEndDate | date:'dd/MM/yy'}}</td>
        <td class="font-tuition">{{tuition.productName}}</td>
        <td class="font-tuition text-right">{{tuition.value | number:'1.2-2'}}</td>
        <td class="font-tuition text-right">{{tuition.discount | number:'1.2-2'}}</td>
        <td class="font-tuition text-right" [ngStyle]="{'color': tuition.total >= 0 ? '#2196F3' : 'red'}">
          {{tuition?.isPartial ? 'P | ' : ''}}{{tuition.total | number:'1.2-2'}}
        </td>
        <td class="font-tuition text-center">
          <i *ngIf="tuition.generate" class="pi pi-check" style="color: #155724"></i>
        </td>
        <td>
          <div class="table-action"
               *ngIf="!(tuition?.isInvalidBoat || tuition?.isContractEndDateStatusExpired)"
               (click)="generateMonthRange(tuition)">
            <i class="pi pi-calendar primary"
               pTooltip="Gerar mensalidades desta embarcação para um período de tempo "
               tooltipPosition="bottom"></i>
          </div>
        </td>
      </tr>
      <tr [hidden]="!tuition.show">
        <td [attr.colspan]="loggedMarina?.marinaCompanies?.length > 0 ? 15 : 14">
          <p-table [value]="tuition.tuitionCustomers" autoLayout="true">
            <ng-template pTemplate="header">
              <tr>
                <th>Proprietário</th>
                <th *ngIf="loggedMarina?.marinaCompanies?.length > 0">Empresa</th>
                <th>Rateio</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Grupo</th>
                <th>Pedido</th>
                <th>Fatura</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
              <tr>
                <td>{{customer.name}}</td>
                <td *ngIf="loggedMarina?.marinaCompanies?.length > 0">
                  {{getCompanyIndex(customer.companyId)}}</td>
                <td class="text-center">{{customer.quota | number:'1.2-2'}}%</td>
                <td class="text-right">{{customer.value | number:'1.2-2'}}</td>
                <td class="text-center">{{customer.dueDate | date:'dd/MM/yy'}}</td>
                <td>{{customer.groupName}}</td>
                <td class="text-center">{{customer.orderNumber ? customer.orderNumber : '----'}}</td>
                <td class="text-center">{{customer.orderNumber ? customer.invoiceNumber : '----'}}</td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="tuition.tuitionCustomers.length == 0">
            <div style="color: red" class="col-12">Sem proprietário</div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
